// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-28De-","header":"header-3hjez","desc":"desc-12nwm","buttons":"buttons-RTIA0"};